Browser = require '@trello/browser'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_in_list')
Util = require 'app/scripts/lib/util'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = t.renderable ({ cover, hasCover, hideCover, hasStickers, attachmentCoverUrl }) ->
  prerenderCoversEnabled = featureFlagClient.get('remarkable.prerender-covers', false)
  colorCoversEnabled = featureFlagClient.get('remarkable.rmk-239', false)

  if !prerenderCoversEnabled || !cover? || hideCover || !hasCover
    return t.div '.list-card-cover.js-card-cover'

  { idAttachment, idUploadedBackground, color, scaled, edgeColor, sharedSourceUrl, size } = cover

  if size == 'full'
    return t.div '.list-card-cover.js-card-cover'

  if color && colorCoversEnabled
    calculatedHeight = if hasStickers then 64 else 32

    return t.div ".list-card-cover.js-card-cover.color-card-cover.color-card-cover-#{color}.is-covered", {
      style: t.stylify({
        height: "#{calculatedHeight}px"
      })
    }

  else if idAttachment || idUploadedBackground
    minWidth = if Browser.isHighDPI() then 600 else 300
    preview =
      Util.smallestPreviewBiggerThan(scaled, minWidth) ?
      Util.biggestPreview(scaled)

    # Not sure how this can happen but supporting it anyway just in case it's a legacy thing.
    if !preview? && idAttachment
      preview =
        url: attachmentCoverUrl

    maxHeight = Math.min(preview.height, 260) # An arbitrarily chosen number
    calculatedHeight = preview.height * 245 / preview.width

    return t.div '.list-card-cover.js-card-cover.is-covered', {
      style: t.stylify({
        height: "#{calculatedHeight}px"
        'background-color': edgeColor ? 'transparent'
        'background-image': "url(\"#{preview.url}\")"
        'background-size': if calculatedHeight <= maxHeight then 'cover' else 'contain'
      })
    }
